import { render } from "./TableDataCell.vue?vue&type=template&id=7d4efebe&ts=true"
import script from "./TableDataCell.vue?vue&type=script&lang=ts"
export * from "./TableDataCell.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__